
import 'components/catalog.tag'
import 'pages/persons/person-new-modal.tag'
import 'pages/persons/persons-category-select-modal.tag'
import 'pages/persons/person-pricetype-select-modal.tag'
import 'modals/import-persons-modal.tag'
import 'modals/export-persons-modal.tag'
riot.tag2('persons-list', '  <div class="col-md-3 hidden-xs hidden-sm">\n    <catalog-tree object="ContactCategory" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n  </div>\n  <div class="col-md-9 col-xs-12 col-sm-12">\n    <catalog search="true" sortable="true" object="Contact" cols="{cols}" allselect="true" reload="true" add="{permission(add, &quot;contacts&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" handlers="{handlers}" dblclick="{permission(personOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-list" filters="{allFilters}">\n      <yield to="body">\n        <datatable-cell name="id"><a class="open-page-item" href="#persons/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n        <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n        <datatable-cell name="email"><i class="fa {row.isActive == &quot;Y&quot; ? &quot;fa-check&quot; : &quot;fa-check text-noactive&quot;}"></i> {row.email}</datatable-cell>\n        <datatable-cell name="countOrders">{row.countOrders}</datatable-cell>\n        <datatable-cell name="amountOrders"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {(row.amountOrders / 1)} / {(row.paidOrders / 1)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n        <datatable-cell name="discount">{row.discount + 0} / {row.progressiveDiscount + 0}</datatable-cell>\n      </yield>\n      <yield to="head">\n        <div class="dropdown" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n          <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n          <ul class="dropdown-menu">\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.addCategory}"><a href="#"><i class="fa fa-fw"></i> Добавить в группы</a></li>\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.setCategory}"><a href="#"><i class="fa fa-fw"></i> Переопределить группы</a></li>\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.setPrice}"><a href="#"><i class="fa fa-fw"></i> Назначить тип цены</a></li>\n          </ul>\n        </div>\n        <button class="btn btn-primary" if="{selectedCount == 1}" onclick="{parent.exportCard}" title="Карточка контакта (XLS)" type="button"><i class="fa fa-file-excel-o" aria-hidden="true"></i></button>\n        <button class="btn btn-primary" type="button" onclick="{parent.exportPersons}" title="Экспорт"><i class="fa fa-upload"></i></button>\n\n      </yield>\n      <yield to="filters">\n        <div class="well well-sm">\n          <div class="form-inline">\n            <div class="form-group col-sm-12 hidden-lg hidden-md">\n              <label class="control-label">Группа</label>\n              <select class="form-control" data-name="idGroup" data-sign="IN">\n                <option value="">Все</option>\n                <option each="{category, i in parent.categories}" value="{category.id}" no-reorder>{category.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Менеджер</label>\n              <select class="form-control" data-name="managerId" data-sign="IN">\n                <option value="">Все</option>\n                <option each="{manager, i in parent.managers}" value="{manager.id}" no-reorder>{manager.title}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Статус</label>\n              <select class="form-control" onchange="{parent.change}">\n                <option value="">Все цены</option>\n                <option value="0">Розничные</option>\n                <option value="1">Корпоративные</option>\n                <option value="2">Оптовые</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="checkbox-inline">\n                <input type="checkbox" data-name="isActive" checked data-bool="Y,N">Активные\n              </label>\n            </div>\n          </div>\n        </div>\n      </yield>\n    </catalog>\n  </div>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Contact';
self.categoryFilters = false;
self.typeFilters = false;
self.allFilters = false;
self.managers = {};

self.cols = [{ name: 'id', value: '#' }, { name: 'regDate', value: 'Регистрация' }, { name: 'email', value: 'Email' }, { name: 'countOrders', value: 'Заказов' }, { name: 'amountOrders', value: 'Сумма / оплачено' }, { name: 'discount', value: 'Скидка / Накоп., %' }];

self.handlers = {
    addCategory: function addCategory(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });

        modals.create('persons-category-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                var groups = [];
                if (items.length > 0) {
                    items.forEach(function (item) {
                        if (groups.indexOf(item.id) === -1) {
                            groups.push({ id: item.id, name: item.name });
                        }
                    });

                    var params = { ids: ids, add: true, groups: groups };
                    API.request({
                        object: 'Contact',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            self.tags.catalog.reload();
                        }
                    });
                }
                self.update();
                this.modalHide();
            }
        });
    },
    setCategory: function setCategory(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });

        modals.create('persons-category-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                var groups = [];
                if (items.length > 0) {
                    items.forEach(function (item) {
                        if (groups.indexOf(item.id) === -1) {
                            groups.push({ id: item.id, name: item.name });
                        }
                    });

                    var params = { ids: ids, upd: true, groups: groups };
                    API.request({
                        object: 'Contact',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            self.tags.catalog.reload();
                        }
                    });
                }
                self.update();
                this.modalHide();
            }
        });
    },
    setPrice: function setPrice() {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });
        modals.create('person-pricetype-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var params = { ids: ids, upd: true, priceType: this.item.priceType };
                API.request({
                    object: 'Contact',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags.catalog.reload();
                    }
                });
                self.update();
                this.modalHide();
            }
        });
    }
};

self.change = function (e) {
    var value = e.target.value;
    if (value == '') {
        self.typeFilters = false;
    } else {
        //var filter = {field: 'priceType', sign: 'IN', value: value}
        self.typeFilters = [{ field: 'priceType', sign: 'IN', value: value }];
    }
    self.Filters();
};

self.add = function () {
    modals.create('person-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = { firstName: _this.name.value, email: _this.email.value };
            API.request({
                object: 'Contact',
                method: 'Save',
                data: params,
                success: function success(response, xhr) {
                    popups.create({ title: 'Успех!', text: 'Контакт добавлен!', style: 'popup-success' });
                    _this.modalHide();
                    self.tags.catalog.reload();
                    if (response && response.id) self.personOpenItem(response.id);
                }
            });
        }
    });
};

self.Filters = function () {
    if (self.typeFilters && self.categoryFilters) self.allFilters = [].concat(self.typeFilters, self.categoryFilters);else if (self.typeFilters) self.allFilters = self.typeFilters;else self.allFilters = self.categoryFilters;
    self.update();
    self.tags.catalog.reload();
};

self.personOpen = function (e) {
    riot.route('/persons/' + e.item.row.id);
};

self.personOpenItem = function (id) {
    riot.route('/persons/' + id);
};

self.importPersons = function (e) {
    modals.create('import-persons-modal', {
        type: 'modal-primary'
    });
};

self.exportPersons = function () {
    var params = { filters: self.allFilters };
    /*API.request({
        object: 'Contact',
        method: 'Export',
        data: params,
        success(response, xhr) {
            let a = document.createElement('a')
            a.href = response.url
            a.download = response.name
            document.body.appendChild(a)
            a.click()
            a.remove()
        }
    })*/
    modals.create('export-persons-modal', {
        type: 'modal-primary'
    });
};

self.exportCard = function (e) {
    var _this = _this2;

    var rows = self.tags.catalog.tags.datatable.getSelectedRows();
    var params = { id: rows[0].id };

    API.request({
        object: 'Contact',
        method: 'Export',
        data: params,
        success: function success(response, xhr) {
            var a = document.createElement('a');
            a.href = response.url;
            a.download = response.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    });
};

self.getManagers = function () {
    self.managers = [];
    API.request({
        object: 'PermissionUser',
        method: 'Fetch',
        success: function success(response) {
            self.managers = response.items;
            self.update();
        }
    });
};

self.getContactCategory = function () {
    self.categories = [];
    API.request({
        object: 'ContactCategory',
        method: 'Fetch',
        success: function success(response) {
            for (var i = 0; i < response.items.length; i++) {
                self.categories.push(response.items[i]);
                if (response.items[i].childs !== undefined) {
                    for (var ii = 0; ii < response.items[i].childs.length; ii++) {
                        self.categories.push(response.items[i].childs[ii]);
                    }
                }
            }
            self.update();
        }
    });
};

self.one('updated', function () {
    self.tags.catalog.on('reload', function () {
        self.getContactCategory();
    });
    self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
        self.selectedCategory = node.__selected__ ? node.id : undefined;
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.id;
            }).join(',');
            self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];
        } else {
            self.categoryFilters = false;
        }
        self.Filters();

        //self.update()
        //self.tags.catalog.reload()
    });
});

self.getContactCategory();
self.getManagers();

observable.on('persons-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/persons/persons-list.tag